'use strict';

const MeasurementItemDirective = () => {

  return {
    bindToController: true,
    controller: 'MeasurementItemController',
    controllerAs: 'vm',
    link: function() {},
    // require: ['annotateCreateAndEdit', '^sbNavDrawerPageView'],
    // require: ['^sbNavDrawerPageView'],
    scope: {
      action: '@', // {create|edit}
    },
    templateUrl: 'dash/nav/navLeft/measurements/item/measurementItem.tpl.html'
  };
};

module.exports = MeasurementItemDirective;



// WEBPACK FOOTER //
// ./src/app/dash/nav/navLeft/measurements/item/MeasurementItemDirective.js